import { Injectable } from '@angular/core';


function getWindow(): any {
  return window;
}


@Injectable()
export class WindowReferenceService {

  constructor() { }

  get nativeWindow() {
    return getWindow();
}

}
